// extracted by mini-css-extract-plugin
module.exports = {"portfolioShadow":"portfolio_portfolioShadow__8WlHl"};